import React, { useRef, useEffect } from 'react';
import './style.scss';
import PropTypes from 'prop-types';

function SkipLinks({
  firstLinkFocused = false,
  secondLinkFocused = false,
  handleEnterKeyPress = () => {},
  handleTopNavigation = () => {},
  handleMainContentNavigation = () => {},
}) {
  const firstLinkRef = useRef(null);
  const secondLinkRef = useRef(null);

  useEffect(() => {
    const focusTimeout = setTimeout(() => {
      if (firstLinkFocused && firstLinkRef.current) {
        firstLinkRef.current.focus();
      } else if (secondLinkFocused && secondLinkRef.current) {
        secondLinkRef.current.focus();
      }
    }, 0);

    return () => clearTimeout(focusTimeout);
  }, [firstLinkFocused, secondLinkFocused]);

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      if (firstLinkFocused) {
        handleEnterKeyPress();
        handleTopNavigation(true);
        handleMainContentNavigation(false);
      } else if (secondLinkFocused) {
        handleEnterKeyPress();
        handleTopNavigation(false);
        handleMainContentNavigation(true);
      }
    }
  };

  const handleEnterPress = () => {
    if (firstLinkFocused) {
      handleEnterKeyPress();
    } else if (secondLinkFocused) {
      handleEnterKeyPress();
    }
  };

  return (
    <div className="skip-links-container">
      <button
        ref={firstLinkRef}
        onClick={handleEnterPress}
        onKeyDown={handleKeyDown}
        tabIndex={0}
        className="skip-link"
        type="button"
      >
        Gå till navigering
      </button>
      <button
        ref={secondLinkRef}
        onClick={handleEnterPress}
        onKeyDown={handleKeyDown}
        tabIndex={0}
        className="skip-link"
        type="button"
      >
        Gå till huvudinnehåll
      </button>
    </div>
  );
}

SkipLinks.propTypes = {
  firstLinkFocused: PropTypes.bool,
  secondLinkFocused: PropTypes.bool,
  handleEnterKeyPress: PropTypes.func,
  handleTopNavigation: PropTypes.func,
  handleMainContentNavigation: PropTypes.func,
};

export default SkipLinks;
